export default __webpack_public_path__ + "static/media/32.57dba012.png";